import { css } from '@emotion/core';
import HamburgerNavigation from '../../components/HamburgerNavigation/HamburgerNavigation';
import NavigationTabs from '../../constants/NavigationTabs';
import mobileContainerHeightCSS from '../../constants/mobileContainerHeightCSS';
import HomeContent from './HomeContent';

export default function HomeLayoutMobile() {
    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                width: 100vw;
                overflow: scroll;
                ${mobileContainerHeightCSS}
            `}
        >
            <HamburgerNavigation selectedTab={NavigationTabs.SYSTEMS} />
            <div
                css={css`
                    padding: 2rem;
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                `}
            >
                <HomeContent />
            </div>
        </div>
    );
}
